import { jsx as a } from "react/jsx-runtime";
import { Progress as i } from "../../../../feedback/Progress/Progress.mjs";
const t = ({
  progressPercentage: s,
  status: r,
  "data-testid": o,
  id: e
}) => /* @__PURE__ */ a(
  i,
  {
    size: "sm",
    "aria-label": r !== "uploading" ? `Upload ${r}` : "Upload in progress",
    value: s,
    id: e && `${e}-progress`,
    "data-testid": o && `${o}-progress`,
    variant: r === "error" ? "error" : "normal",
    mb: 2
  }
);
export {
  t as FileListItemProgress,
  t as default
};
